module.exports = __webpack_public_path__ + "static/media/campaign.2936ed56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/campaign.svg
// module id = 1517
// module chunks = 1